"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.USER_CURRENCY = exports.IntlNumberFormatter = exports.IntlCurrencyFormatter = exports.FormatOwnerName = exports.FormatNumberForLocale = exports.FormatFileSize = exports.FormatAsCurrencyForLocale = void 0;
require("core-js/modules/es.number.to-fixed.js");
var _Constants = require("../utilities/Constants");
var _Currencies = require("../utilities/Internationalization/Currencies");
var _dataHelpers = require("./dataHelpers");
const USER_CURRENCY = exports.USER_CURRENCY = _Currencies.IntlCountryCurrencyMap[_Constants.USER_COUNTRY_CODE] || 'AUD';
const IntlCurrencyFormatter = () => new Intl.NumberFormat(_Constants.USER_LOCALE, {
  style: 'currency',
  currency: USER_CURRENCY
});
exports.IntlCurrencyFormatter = IntlCurrencyFormatter;
const IntlNumberFormatter = () => new Intl.NumberFormat(_Constants.USER_LOCALE);

/**
 * Returns a decimal number in the correct internationalized format based on the users locale
 *
 * @param {number} - The decimal number to be formatted
 * @returns {number} A formatted number
 */
exports.IntlNumberFormatter = IntlNumberFormatter;
const FormatNumberForLocale = decimalNumber => {
  return IntlNumberFormatter().format(decimalNumber);
};

/**
 * Returns a decimal number in the correct internationalized currency format based on the users locale
 *
 * @param {number} - The decimal number to be formatted
 * @returns {number} A formatted number with currency symbol
 */
exports.FormatNumberForLocale = FormatNumberForLocale;
const FormatAsCurrencyForLocale = value => {
  try {
    return "".concat(value < 0 ? '-' : '').concat(IntlCurrencyFormatter().format(Math.abs(value)));
  } catch (e) {
    return "".concat(value < 0 ? '-' : '', "$").concat(Math.abs(value).toFixed(2));
  }
};

/**
 * Takes a file size in bytes from a file input field and formats it into user-friendly sizes.
 * https://www.gbmb.org/mb-to-bytes
 *
 * @param {number} - The file size number in bytes to be formatted
 * @returns {string} A formatted number with user-friendly units
 */
exports.FormatAsCurrencyForLocale = FormatAsCurrencyForLocale;
const FormatFileSize = fileSize => {
  if (fileSize < 1024) {
    return "".concat(fileSize, " bytes");
  }
  if (fileSize >= 1024 && fileSize < 1048576) {
    return "".concat((fileSize / 1024).toFixed(1), " KB");
  }
  if (fileSize >= 1048576 && fileSize < 1e+9) {
    return "".concat((fileSize / 1048576).toFixed(1), " MB");
  }
  return "".concat((fileSize / 1e+9).toFixed(1), " GB");
};
exports.FormatFileSize = FormatFileSize;
const FormatOwnerName = owner => {
  const {
    name,
    firstName,
    surname,
    email
  } = owner;
  if (name) {
    return name;
  }
  if (firstName) {
    if (surname) {
      return "".concat(firstName, " ").concat(surname);
    }
    return "".concat(firstName);
  }
  if (surname) {
    return "".concat(surname);
  }
  if (email) {
    const {
      firstName,
      lastName: surname
    } = (0, _dataHelpers.ExtractNamePieces)(email.split('@')[0]);
    return "".concat(firstName, " ").concat(surname);
  }
  return '';
};
exports.FormatOwnerName = FormatOwnerName;
var _default = exports.default = {
  FormatNumberForLocale,
  FormatAsCurrencyForLocale,
  FormatOwnerName
};